<template>
  <div>
    <button @click="$root.$emit('show::custom::modal', 'test')">
      modal
    </button>
    <button @click="$root.$emit('show::custom::modal', 'test-2')">
      modal2
    </button>
    <form>
      <custom-input
        id="my-input"
        v-model="name"
        v-focus
        type="text"
        label="Username:"
        error-text="Here is a big fat error"
        input-class="is-danger"
      />
      <custom-input
        id="my-input"
        v-model="age"
        min="0"
        max="100"
        type="number"
        label="Age:"
        info-text="Give the user some information here"
        warning-text="Here is some God-awful warning"
      />
    </form>
  </div>
</template>

<script>
import CustomInput from '@/components/Shared/CustomInput'
export default {
  name: 'ModalTestPage',
  components: {
    CustomInput
  },
  data () {
    return {
      name: '',
      age: ''
    }
  }
}
</script>
